import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GeneralService } from 'src/app/providers/general/general.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';

@Component({
  selector: 'app-search-emp',
  templateUrl: './search-emp.component.html',
  styleUrls: ['./search-emp.component.scss']
})
export class SearchEmpComponent implements OnInit {

  @Input() empdata: any;
  @Output() greetEvent = new EventEmitter();
  empID;
  result: any;
  constructor(private generalServe: GeneralService,
              private notifyService: NotificationService) {
   }

  ngOnInit(): void {
    console.log(this.empdata);
  }

  onInput(event): void {
    // console.log(event.target.value);
  }

  searchEmp(): void {
    this.generalServe.searchEmployee(this.empID).subscribe(res => {
      this.result = res;
      if (this.result.status) {
        this.empID = this.result.data[0].name;
        this.greetEvent.emit(this.result.data);
        // data.empId = this.result.data[0].name;
        // data.isReadonly = true;
      } else {
        this.notifyService.showInfo(this.result.msg, 'Info!');
      }
    }, err => {});
  }
}
